<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <v-row>
      <v-col v-if="listaSubEstoque.length > 1" cols="12">
        <v-autocomplete
          v-model="subEstoqueSelecionado"
          :items="listaSubEstoque"
          label="Selecionar Estoque"
          clearable
        ></v-autocomplete>
      </v-col>
      
      <v-col cols="6">
        <v-autocomplete
          v-model="familiaSelecionada"
          :items="listaDeFamilias"
          label="Selecionar Familia"
          clearable
        ></v-autocomplete>
      </v-col>

      <v-col cols="6">
        <v-autocomplete
          v-model="filtroVazioSelecionado"
          :items="filtroVazios"
          label="Filtrar Zerados:"
          clearable
        ></v-autocomplete>
      </v-col>
    </v-row>

    <br>
    <DatatableMultiSelecao
      v-show="showSkeletonTable == false"
      :tableTitle="'Produtos em estoque'"
      :printButtonName="'Imprimir Estoque'"
      :tableHeader="headers"
      :tableRows="itens"
      :itemKey="'itemUnidade.numeroItemUnidade'"
      v-on:datatable-print="gerarEXCEL"
    ></DatatableMultiSelecao>

    <SkeletonTable
      :showSkeletonTable="showSkeletonTable == true"
    ></SkeletonTable>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DatatableMultiSelecao from "../components/DatatableMultiSelecao";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver';

export default {

  components: {
    DatatableMultiSelecao,
    SkeletonTable,
    Alertas,
  },

  data: () => ({
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    showSkeletonTable: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "itemUnidade.numeroItemUnidade",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      { 
        text: "Nome Produto", 
        value: "nomeItemPadrao" 
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Total em Estoque",
        value: "itemUnidade.quantidadeEstoque",
      },
      {
        text: "Família",
        value: "item.indicadorStatusFamilia"
      },
      {
        text: "Subestoque",
        value: "subestoque.nomeSubestoque",
      }
    ],

    config: {
       headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },
    subEstoqueSelecionado: null,
    listaSubEstoque: [],
    familiaSelecionada: null,
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações"
      },
      {
        value: 2,
        text: "Materiais"
      },
      {
        value: 3,
        text: "Psicotrópicos"
      },
      {
        value: 4,
        text: "Saneantes"
      },
      {
        value: 5,
        text: "Cosméticos"
      },
      {
        value: 6,
        text: "Nutrição"
      },
      {
        value: 7,
        text: "Antimicrobianos"
      },
      {
        value: 8,
        text: "Amostra Grátis",
      },
      {
        value: 9,
        text: "Maleta de Emergência",
      },
      {
        value: 10,
        text: "Doação",
      },
      {
        value: 11,
        text: "Teste Rápido"
      },
      {
        value: 12,
        text: "USO INTERNO"
      }
    ],

    descricaoTela: "ItensUnidade",
    numeroEndereco: store.state.numeroEndereco,

    filtroVazioSelecionado: true,

    //POPULA ARRAY PARA TABELA
    itens: [],
    filtroVazios: [
      { value: true, text: 'Não retornar vazios' },
      { value: false, text: 'Retornar vazios' },
    ],

  }),

  created() {
    this.initialize();
  },

  watch:{
    subEstoqueSelecionado(){
      this.listarMateriais()
    },

    familiaSelecionada(){
      this.listarMateriais()
    },

    filtroVazioSelecionado() {
      this.listarMateriais()
    }
  },

  methods: {
    async initialize() {
      try {
        await this.listarMateriais();
        await this.listarSubestoque();
     
      } catch (error) {
        console.log(error);
      }
    },

    async listarMateriais() {
      this.showSkeletonTable = true;
      try {
        const response = await axios.put("itemEstoqueUnidade", { numeroEndereco: this.numeroEndereco, numeroSubEstoque: this.subEstoqueSelecionado, indicadorStatusFamilia: this.familiaSelecionada, semVazios: this.filtroVazioSelecionado}, this.config);
        this.itens = response.data;
        
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listarSubestoque() {
      try {
        const buscarSubEstoque = await axios.put("subestoque", { numeroEndereco: this.numeroEndereco }, this.config)
        this.listaSubEstoque = buscarSubEstoque.data.map(function(subEstoque){
          return {
            text: subEstoque.nomeSubestoque,
            value: subEstoque.numeroSubestoque
          }
        })
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    //OBS: NAO IMPLEMENTADO
    gerarPDF() {
      var pdfMake = require('pdfmake/build/pdfmake.js')

      if (pdfMake.vfs == undefined){
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      
      var docDefinition = {
        info: {
          title: 'Relatório de Solicitação',
        },
        content: [
          {text: "Estoque de Produtos", style: 'header'},
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            margin: [0, 0, 0, 24]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 16, 0, 8]
          },
          table: {
            margin: [0, 16, 0, 16]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          },
          subtext: {
            fontSize: 14, 
            bold: true, 
            margin: [0, 16, 0, 8]
          },
          columns: {
            columnGap: 20,
            margin: [0, 32, 0, 32]
          },
          assinatura: {
            columnGap: 20,
            margin: [0, 40, 0, 16]
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      }

      pdfMake.createPdf(docDefinition).open()
    },

    gerarEXCEL(listaMaterial) {
      try {
        listaMaterial.sort(function(a, b) {
          if(a.nomeItemPadrao){
            var textA = a.nomeItemPadrao.toUpperCase();
          }
          if(b.nomeItemPadrao){
            var textB = b.nomeItemPadrao.toUpperCase();

          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        const workbook = new Workbook()
        var worksheet = workbook.addWorksheet("Materiais em Estoque", { views:[ { showGridLines: false } ]})

        worksheet.columns = [
            { key: 'col1', width: 25 },
            { key: 'col2', width: 25 },
            { key: 'col3', width: 70 },
            { key: 'col4', width: 25 },
            { key: 'col5', width: 30 },
            { key: 'col6', width: 20 }
        ];

        const linhaTitulos = worksheet.addRow({
          col1: 'ID',
          col2: 'Lote',
          col3: 'Produto',
          col4: 'Validade',
          col5: 'Quantidade Total em Estoque',
          col6: 'Subestoque'
        })
        linhaTitulos.font = { bold: true };

        listaMaterial.map((materialSelecionado) => {
          
          worksheet.addRow({
            col1: materialSelecionado.itemUnidade.numeroItemUnidade,
            col2: materialSelecionado.item.lote,
            col3: materialSelecionado.nomeItemPadrao,
            col4: materialSelecionado.item.validade,
            col5: materialSelecionado.itemUnidade.quantidadeEstoque,
            col6: materialSelecionado.subestoque.nomeSubestoque
          }).alignment = { vertical: 'top', horizontal: 'left' };

        })

        //STYLE BORDER
        var borderStyles = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
        
        worksheet.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          saveAs(blob, "materiais-em-estoque.xlsx");
        });
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>


